"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PractitionerRoleNotAvailable = void 0;
/**
 * A specific set of Roles/Locations/specialties/services that a practitioner may perform at an organization for a period of time.
 */
var PractitionerRoleNotAvailable = /** @class */ (function () {
    function PractitionerRoleNotAvailable() {
    }
    return PractitionerRoleNotAvailable;
}());
exports.PractitionerRoleNotAvailable = PractitionerRoleNotAvailable;
